export default function ProblemSolution() {
  const problems = [
    { icon: 'ri-money-dollar-circle-line', text: 'Высокие комиссии агентов' },
    { icon: 'ri-file-list-3-line', text: 'Сложный процесс заказа' },
    { icon: 'ri-truck-line', text: 'Непрозрачная логистика' },
  ];

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="lg:w-1/2 w-full">
            <div className="relative rounded-2xl overflow-hidden" style={{ height: '420px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20laptop%20showing%20spreadsheet%20on%20screen%2C%20clean%20desk%20with%20warm%20beige%20background%2C%20natural%20light%20from%20window%2C%20editorial%20productivity%20photography%2C%20soft%20shadows%2C%20cozy%20professional%20aesthetic&width=800&height=600&seq=problem-solution-01&orientation=landscape"
                alt="YOYBUY spreadsheet workspace"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute top-4 left-4 flex flex-wrap gap-2">
                {['100,000+ заказов', 'Доставка в СНГ', 'Безопасные платежи'].map((tag) => (
                  <span key={tag} className="px-3 py-1.5 rounded-lg bg-white/20 backdrop-blur-md text-white text-xs font-medium whitespace-nowrap">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:w-1/2 w-full flex flex-col gap-8">
            <div>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6">
                Почему агенты — это сложно?
              </h2>
              <div className="flex flex-wrap gap-3 mb-8">
                {problems.map((p, i) => (
                  <span
                    key={p.text}
                    className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap ${
                      i === 0
                        ? 'border-2 border-primary-300 text-primary-700 bg-primary-50'
                        : 'text-foreground-600 bg-background-100'
                    }`}
                  >
                    <i className={`${p.icon} text-base`}></i>
                    {p.text}
                  </span>
                ))}
              </div>
            </div>

            <div className="bg-foreground-950 rounded-2xl p-8 flex flex-col md:flex-row gap-6">
              <div className="flex-1">
                <span className="inline-block px-3 py-1 rounded-lg bg-accent-500/20 text-accent-400 text-xs font-medium mb-4 whitespace-nowrap">
                  YOYBUY Solution
                </span>
                <h3 className="font-heading text-2xl font-bold text-white mb-3">
                  Автоматизированная система закупок
                </h3>
                <p className="text-white/70 text-base leading-relaxed">
                  YOYBUY Spreadsheet заменяет хаос переписки с агентами на прозрачную таблицу. Вы видите каждую позицию, её цену, статус и трек-номер — всё в одном окне. Никаких скрытых комиссий и потерянных заказов.
                </p>
              </div>
              <div className="md:w-[140px] flex-shrink-0 flex items-center justify-center">
                <div className="w-20 h-20 rounded-2xl bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-file-excel-2-line text-accent-400 text-3xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}